module.exports = __webpack_public_path__ + "img/2009_S.cb790e1e.png";